import ListProviders from "@/views/agro_exporter/certifications/query_providers/ListProviders.vue";
import ShowOrganization from "@/views/agro_exporter/certifications/query_providers/ShowOrganization.vue";
import ShowPackingHouse from "@/views/agro_exporter/certifications/query_providers/ShowPackingHouse.vue";
import ShowProducer from "@/views/agro_exporter/certifications/query_providers/ShowProducer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "certifications",
  permission: "query_providers"
});

export default [
  {
    path: "/ae/:agro_exporter_id/certifications/query_providers/list_providers",
    name: routeName(""),
    redirect: { name: routeName("list_providers") }
  },
  {
    path: "/ae/:agro_exporter_id/certifications/query_providers/list_providers",
    name: routeName("list_providers"),
    component: ListProviders,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/query_providers/show_organization/:organization_id",
    name: routeName("show_organization"),
    component: ShowOrganization,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/query_providers/show_packing_house/:packing_house_id",
    name: routeName("show_packing_house"),
    component: ShowPackingHouse,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/query_providers/show_producer/:producer_id",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  }
];
